// this file is automatically generated by git-version script
export const version = {
  name: 'amg-provider-client',
  version: '1.64.1',
  commit: 'b90bd77a02325508351b9e053ae666d90a201070',
  branch: 'platinum',
  dateGenerated: '2026-06-10T15:30:54.818Z',
};